import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./layout/Layout";
import ScrollToTop from "./ScrollToTop";
import HomePage from "./HomePage";
import AboutPage from "./AboutPage";
import Services from "./Services";
import Internship from "./careers/Internship";
import CareerJobs from "./careers/CareerJobs";
import ContactPage from "./ContactPage";
import ChatBox from "./ChatBox";
import Gallery from "./Gallery";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <ChatBox />

      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/our-services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />


          {/* CAREERS – ONLY 2 PAGES */}
          <Route path="/careers/internship" element={<Internship />} />
          <Route path="/careers/jobs" element={<CareerJobs />} />

          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
